"use strict";
// This file contains objects documented here: https://docs.slack.dev/reference/block-kit/block-elements
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=block-elements.js.map